import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { COLOR_PICKER_COLORS } from '../../../util/vars';
import { Button, Collapse, Tag } from '../../../components';
import type { TagProps } from '../../../components/tag/Tag';

interface ColorPickerProps {
  label: string;
  title?: string;
  value: TagProps['color'];
  onChange: (value: number ) => void;
}

const ColorPicker = ({ title, label, value, onChange }: ColorPickerProps): JSX.Element => {

  const { translate } = useI18n();
  const [ open, setOpen ] = useState(false);

  const colors = Object.keys(COLOR_PICKER_COLORS);

  return (
    <div className={'space-y-2'}>
      {title && <h2 className={'font-bold'}>{title}</h2>}
      <div className={'flex items-center space-x-2'}>
        <Tag color={value}>{label.length ? label : '—'}</Tag>
        <Button
          isOutline
          color={'black'}
          onClick={() => setOpen((prevOpen) => !prevOpen)}
        >{translate('pages.ROSTER_MANAGEMENT.COLOR_PICKER.CHOOSE_COLOR')}</Button>
      </div>
      <Collapse when={open}>
        <div className={'flex flex-wrap gap-4 items-center justify-center my-4'}>
          {colors.map((key) => {
            const colorKey = Number(key);
            return (<Tag
              key={key}
              color={COLOR_PICKER_COLORS[colorKey]}
              isCircle
              className={'w-10 h-10 cursor-pointer'}
              onClick={() => onChange(colorKey)}
            />);
          })}
        </div>
      </Collapse>
    </div>
  );
};

ColorPicker.displayName = 'ColorPicker';

export { ColorPicker };
